module.exports = __webpack_public_path__ + "static/vision-logo-55f87efe51bcf4b7fe96d12e41ec1d31.svg";